@if (visible) {
  <div
    class="cookie-banner"
    role="dialog"
    aria-live="polite"
    aria-label="Cookie consent"
    >
    <div class="content">
      <p class="title">Cookies & privacy</p>
      <p class="text">
        We use essential cookies and storage to keep this website working
        properly, such as remembering your basket. We also use cookies to help
        improve the website experience.
        <button type="button" class="link" (click)="openPolicy()">
          Read our Cookie Policy</button
          >.
        </p>
      </div>
      <div class="actions">
        <button type="button" class="btn primary" (click)="acceptAnalytics()">
          Accept
        </button>
      </div>
    </div>
  }
